import { makeStyles, useTheme } from '@material-ui/core';
import { AIADMIN_PRIMARY_COLOR, AIADMIN_TEXT_SECONDARY, DRAWER_HOVER } from './CommonThemes';

// eslint-disable-next-line no-unused-vars
const useSideDrawerStyles = (_props = {}) => {
  const theme = useTheme();
  const useStyles = makeStyles({
    listContainer: {
      backgroundColor: AIADMIN_PRIMARY_COLOR,
      height: '100vh',
      overflowY: 'auto',
      paddingTop: '70px',
      overflowX: 'hidden'
    },
    listItem: {
      padding: '0px',
      color: AIADMIN_TEXT_SECONDARY,
      '& span': {
        color: AIADMIN_TEXT_SECONDARY
      },
      '& svg': {
        fill: AIADMIN_TEXT_SECONDARY
      }
    },
    drawerPaper: {
      width: () => (_props.isOpened ? 250 : 60),
      transition: 'width 0.3s ease-in-out',
      backgroundColor: AIADMIN_PRIMARY_COLOR,
      color: 'white',
      height: '100vh',
      overflowX: 'hidden',
      overflowY: 'auto',
      display: 'flex',
      flexDirection: 'column',
      borderRight: '1px solid rgba(255, 255, 255, 0.12)',
      boxShadow: '2px 0px 5px rgba(0, 0, 0, 0.5)'
    },
    listItemButton: {
      justifyContent: 'flex-start',
      paddingLeft: '16px',
      paddingRight: '16px',
      minHeight: '48px' // Ensures consistent height
    },
    listItemIcon: {
      minWidth: '40px',
      justifyContent: 'start'
    },
    listItemText: {
      display: () => (_props.isOpened ? 'block' : 'none') // Ensures text is visible when expanded
    },
    hamburgerButton: {
      '&&': {
        position: 'fixed',
        top: '20px',
        left: '10px',
        zIndex: 1301,
        backgroundColor: theme.palette.background.darkBlue,
        color: '#fff',
        paddingTop: '6px',
        '&:hover': {
          backgroundColor: DRAWER_HOVER
        }
      }
    },
    '@global': {
      'body.pm-new-version-modal-open .pm-side-drawer-toggle': {
        display: 'none !important'
      }
    }
  });

  return useStyles();
};

export default useSideDrawerStyles;
